import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataProcessingService } from './data-prcessing.service';
import { LoggerService } from './logger.service';

import { GenericResponseWithTotal } from '../interfaces/generic.interface';
import { Card, MonthlyReportItem, NewUserCard, Statistics } from '../interfaces/cards.interface';
import { Observable, tap, map} from 'rxjs';
import { Branch } from '../interfaces/branch.interface';

@Injectable({
  providedIn: 'root'
})
export class BranchService {
  public branches: Branch[] = [];

  private get apiUrl(): string {
    return this.loggerService.resolveApiUrl('branch');
  }

  constructor(
    private http: HttpClient,
    private dataProcess: DataProcessingService,
    private loggerService: LoggerService
  ) { }

  getBranches(): Observable<Branch[]> {
    if (this.branches.length > 0) {
      return new Observable<Branch[]>(observer => {
        observer.next(this.branches);
        observer.complete();
      });
    }
    return this.http.get<GenericResponseWithTotal<Branch>>(this.apiUrl).pipe(
      tap(response => this.branches = response.items),
      map(response => response.items)
    );
  }

  getBranchesNoCache(): Observable<Branch[]> {
    return this.http.get<GenericResponseWithTotal<Branch>>(this.apiUrl).pipe(
      tap(response => this.branches = response.items), // Cache the branches
      map(response => response.items)
    );
  }

  getBranch(id: number): Observable<Branch> {
    return this.http.get<Branch>(`${this.apiUrl}/${id}`);
  }

}
